import * as React from "react";
import {Typography, withStyles} from "@material-ui/core";
import {InputStyle} from "@components/common/input/input.style";
import {Error} from "@material-ui/icons";

interface IInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    label?: React.ReactNode | undefined;
    classes: any;
    error?: string | undefined;
    labelStyle?: React.CSSProperties;
    rootStyle?: React.CSSProperties;
    divRef?:React.RefObject<HTMLDivElement> 
}

interface IInputState {
    isFocused: boolean;
}

class Input extends React.Component<IInputProps, IInputState> {
    private inputRef: React.RefObject<HTMLInputElement>;

    constructor(props: IInputProps) {
        super(props);
        this.inputRef = React.createRef();

        this.state = {
            isFocused: false,
        };

        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.handleInputFocus = this.handleInputFocus.bind(this);
    }

    public render() {
        const {isFocused} = this.state;
        const {label, labelStyle, rootStyle, classes, error, children, divRef, ...rest} = this.props;
        const inputClassName = error ? classes.invalidInput : (isFocused ? classes.focusedInput : '');
        const labelClassName = error ? classes.invalidLabel : classes.validLabel;

        return (
            <div className={classes.root} ref={divRef} onClick={() => {if (this.inputRef.current) {this.inputRef.current.focus();}}}>
                <label htmlFor={this.props.id} className={classes.labelWrapper} style={labelStyle}>
                    {label && (<Typography className={`${classes.label} ${labelClassName}`}>{label}</Typography>)}
                    <div className={`${classes.inputContainer} ${inputClassName}`} style={rootStyle}>
                        <input
                            {...rest}
                            ref={this.inputRef}
                            className={classes.input}
                            onBlur={this.handleInputBlur}
                            onFocus={this.handleInputFocus}
                        />
                        {(children || error) && (
                            <div className={classes.inputActions}>
                                {error && (<Error className={classes.errorIcon} color="error" fontSize="small"/>)}
                                {children && (children)}
                            </div>
                        )}
                    </div>
                </label>

                {error && <span className={classes.errorMessage}>{error}</span>}
            </div>
        );
    }

    private handleInputBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        this.setState({
            isFocused: false,
        });
        const inputElement = this.inputRef.current;
        if (inputElement) {
            inputElement.reportValidity(); // Trigger HTML input validity check
        }

        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
    }

    private handleInputFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        this.setState({
            isFocused: true,
        });

        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    }
}

export default (withStyles(InputStyle)(Input));



// WEBPACK FOOTER //
// ./src/components/common/input/input.component.tsx